import React from "react";
export default function Multiplication_Operator() {
  return <div>Excel_Arithmetic_Multiplication_Operator</div>;
}
